import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import styles from "./choose-courses-new.module.css"

@tagName("")
export default class ChooseCoursesForTemplate extends Component {
  readonly styles = styles

  coursesWithTemplateInfo
  courses!: Array<Course>
  planbook!: Planbook
  rotationCalendar!: RotationCalendar
  selectedCourseIds!: Array<string> | []
  onToggleCourse!: Function
  activeTemplateIds!: Array<string> | []
}
